// react
import { ReactNode } from 'react';

// router
import { Link as RouterLink } from 'react-router-dom';

// types
import { Project } from '../../../@types';

// mui
import { Link, LinkProps } from '@mui/material';

// utils
import { buildV2ProjectUrl, buildV1ProjectUrl } from '../../../utils/v2Host';

// props
export interface LinkProjectProps extends LinkProps {
	children?: ReactNode;
	project: Project;
	[x: string]: unknown;
}

export const LinkProject = ({ account, children, project, sx, ...props }: LinkProjectProps) => {
	// vars
	const content = children || project.name;

	// If the project is V2 and we're on a recognized V1 deployment host
	// (dev/qa/prod), link out to the V2 site instead of routing internally.
	// Conversely, a V1 project opened on a V2 host links back to the V1 site.
	const v2Url = project.version === '2' ? buildV2ProjectUrl(project.idWbg) : null;
	const v1Url = project.version !== '2' ? buildV1ProjectUrl(project.idWbg) : null;
	const crossHostUrl = v2Url ?? v1Url;

	if (crossHostUrl) {
		return (
			<Link
				fontWeight={600}
				href={crossHostUrl}
				sx={{ wordBreak: 'break-word', ...sx }}
				underline="hover"
				{...props}>
				{content}
			</Link>
		);
	}

	return (
		<Link
			component={RouterLink}
			fontWeight={600}
			sx={{ wordBreak: 'break-word', ...sx }}
			to={`/project/${project.idWbg}`}
			underline="hover"
			{...props}>
			{content}
		</Link>
	);
};
